const doc = [({"en":({"js":({"admin":({"economy":({"accounts":({"index":({"account_dimensions":"Account dimensions"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;